<div><app-dropdown :items="items" icon="globe"></app-dropdown></div>